export default "__VITE_PUBLIC_ASSET__7c2df90b__"